import axios from 'axios';
import VueSocialSharing from "vue-social-sharing";
import {globalMixin} from '@/mixins/global.js'
import VueImageZoomer from 'vue-image-zoomer'; //<< It can be imported globally. Otherwise, it will cause an error in production

export default defineNuxtPlugin((nuxtApp) => {
    // configure the axios's default base url
    const config = nuxtApp.$config;
    const {dev_base, prod_base} = config.public || {};
    axios.defaults.baseURL = ((process.env.NODE_ENV === "development" ? dev_base : prod_base) || 'http://localhost:3000') + '/';

    // activate service worker registration
    if (navigator && navigator.serviceWorker) {
        navigator.serviceWorker.register("firebase-messaging-sw.js", {scope: "./"}).then(
            (registration) => {},
            (error) => {},
        );
    }
    // Inject mixin(s) - append mixins here
    nuxtApp.vueApp.mixin(globalMixin);

    // Inject component(s) globally
    nuxtApp.vueApp.use(VueImageZoomer)
    nuxtApp.vueApp.use(VueSocialSharing);
    // nuxtApp.vueApp.use(Particles);
});